import Cookies from "js-cookie";
import { getRuntimeConfig } from "src/pages/api/config.api";

const populateAcceptLanguageHeader = () => {
  const cookies = Cookies.get() || {};

  if (cookies.ud_locale) {
    // Convert locale string to Accept-Language standard
    const udLocaleConverted = cookies.ud_locale.split("_").join("-");
    return {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "Accept-Language": udLocaleConverted
    };
  }
};

const populateAuthorizationHeader = () => {
  const cookies = Cookies.get() || {};

  if (cookies.access_token) {
    return {
      Authorization: `Bearer ${cookies.access_token}`
    };
  }
};

export const fetchData = <TData, TVariables>(
  query: string,
  variables?: TVariables,
  options?: RequestInit["headers"]
): (() => Promise<TData>) => {
  return async () => {
    const fullGraphQLUrl = new URL(getRuntimeConfig('GRAPHQL_URL'), 'https://www.udemy.com');
    const isServer = typeof window === 'undefined';
    const url = isServer
        ? fullGraphQLUrl
        : `${window.location.origin}${process.env.DEPLOY_ENV === 'local' ? '/dev-portal': ''}${fullGraphQLUrl.pathname}`;

    const res = await fetch(url as string, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...populateAcceptLanguageHeader(),
        ...populateAuthorizationHeader(),
        ...options
      },
      body: JSON.stringify({
        query,
        variables
      })
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0] || {};
      throw new Error(message || "Error…");
    }

    return json.data;
  };
};
